import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useLeaseNeedAction } from "../../hooks/useLease"

export const useLeaseNeedActionAlertCount = (token: string) => {
    const [count, setCount] = useState(0)
    const { data, refetch } = useLeaseNeedAction(token)

    useEffect(() => {
        setCount(data?.data.length ?? 0)
    }, [data])

    // locationが変更されるたびにカウントを更新する
    const location = useLocation()
    useEffect(() => {
        refetch()
        // useFetchへの引数を渡すときにメモ化を行っていないのでrefetchを加えてはいけない
        // ちゃんとやるならuseFetchへの引数もメモ化するべきだが、他のところでもやっておらず作業が広範囲に及ぶ割にメモ化しておいた方がいいケースが珍しいので一旦このままでもよいかなという気持ち
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    return {
        count
    }
}
